import { render } from "./Twitter.vue?vue&type=template&id=6ba458f5"
import script from "./Twitter.vue?vue&type=script&lang=js"
export * from "./Twitter.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/landing/landing/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__